// Re-export shim for the api-backed notificationService.

export const NOTIFICATION_CHANNELS = {
  IN_APP: 'in_app',
  PUSH: 'push',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
  EMAIL: 'email'
};

export const NOTIFICATION_TYPES = {
  SESSION_SAVED: 'session_saved',
  REVISION_DUE: 'revision_due',
  QUALITY_DROP: 'quality_drop',
  MILESTONE: 'milestone',
  ANNOUNCEMENT: 'announcement',
  ATTENDANCE: 'attendance'
};

export const NOTIFICATION_STATUS = {
  PENDING: 'pending',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed'
};

export const countUnread = (items) => {
  if (!Array.isArray(items)) return 0;
  return items.filter((n) => n && n.read !== true).length;
};

export { notificationService } from './notificationServiceV2';
export { default } from './notificationServiceV2';
